<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Maintenance Work Order - Form
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="7">
                    <b-row>
                        <b-col md="6">
                        <b-input-group>
                            <b-input-group-prepend><label>Work Order Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.maintSpkNo" readonly></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col md="6">                            
                        <b-input-group>
                            <b-input-group-append><span class="input-group-text">WorkOrder Date</span></b-input-group-append>
                            <b-form-input v-model="model.orderdate" type="date" @change="tanggalBerubah" :state="!$v.model.orderdate.$error"></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-row >  
                    <b-row>
                        <b-col md="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Requesition No.</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.requestno" ></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuRequestShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-row>    
                    <b-input-group >
                        <b-input-group-prepend><label >Work Order Title</label></b-input-group-prepend>
                        <b-form-input v-model="model.inspectName" :state="!$v.model.inspectName.$error" placeholder="Work Order Name/Title"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Work/Task Detail</label></b-input-group-prepend>
                        <b-form-textarea :rows="5" :max-rows="10" v-model="model.inspectDetail" :state="!$v.model.inspectDetail.$error" ></b-form-textarea>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Maintenance by</label></b-input-group-prepend>
                        <!-- <b-form-radio-group  v-model="model.internal" class="ml-2 mt-1">
                            <b-form-radio :value="1">Internal</b-form-radio>
                            <b-form-radio :value="0">Vendor</b-form-radio>
                        </b-form-radio-group>                   -->
                        <b-input-group-prepend>
                        <b-form-select style="width:110px; margin-right:2px;"  v-model="model.internal" :plain="true" :options="InterExtern" ></b-form-select>
                        </b-input-group-prepend>
                        <b-form-input readonly v-model="model.vendorinfo" :state="!$v.model.vendor_id.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuVendorShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-row>
                        <b-col lg="7" >
                            <b-input-group >
                                <b-input-group-prepend><label>Estimate Cost</label></b-input-group-prepend>
                                <b-input-group-prepend> <span class="input-group-text" style="width:80px !important;">{{uanguser}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="model.costEstimate" :precision="2"></my-number>
                            </b-input-group>
                        </b-col>
                    </b-row >  
                </b-col>
                <b-col md="5">
                    <b-input-group>
                        <b-input-group-prepend><label>Maintenance Doc.#</label></b-input-group-prepend>
                        <b-form-input v-model="model.referDoc" readonly class="mr-1" ></b-form-input>  
                        <b-form-input v-model="model.manualName" readonly style="width:40% !important;" ></b-form-input>                                        
                        <b-input-group-append>
                            <b-btn text="Button" @click="lkuMaintenguideShow=true" :disabled="(model.inspMstrKey)">
                                <i class="fa fa-search"></i>
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Fixed Asset</label></b-input-group-prepend>
                        <b-form-input v-model="model.asetid" readonly class="mr-1" :state="!$v.model.asetkey.$error"></b-form-input>  
                        <b-form-input v-model="model.asdesc" readonly style="width:40% !important;" :state="!$v.model.asetkey.$error"></b-form-input>                                        
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuFixedAssetShow=true" :disabled="(model.requestkey)">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Group/Category</label></b-input-group-prepend>
                        <b-form-input v-model="model.catgname" readonly></b-form-input>                                        
                    </b-input-group>
                    <b-row>
                        <b-col lg="7" >
                            <b-input-group >
                                <b-input-group-prepend><label>Model/Type</label></b-input-group-prepend>
                                <b-form-input v-model="model.asmodel" readonly style="width:40% !important;"></b-form-input>
                                <b-form-input v-model="model.asyermad" readonly class="ml-1"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="5">                            
                            <b-input-group >
                                <b-input-group-prepend class="d-md-inline d-lg-none"><label>S/N</label></b-input-group-prepend>
                                <b-input-group-prepend class="d-md-none d-lg-inline" style="margin-top: 6px !important;"><span>S/N &nbsp;</span></b-input-group-prepend>
                                <b-form-input v-model="model.asserial"  readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <h4>DIMENSION</h4>
                    <v-dim :model="model" :key="updateDimHdr" ></v-dim>
                </b-col>
              </b-row>
            <b-row class="justify-content-center mb-2">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                <button class="btn btn-primary" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </b-row>

        </b-card>
        <b-modal v-model="lkuVendorShow" size="lg" :hide-footer="true" title="List of Vendor" :centered="true">
            <lku-vendor @click="onSelectLkuVendor"></lku-vendor>
        </b-modal>  
        <b-modal v-model="lkuFixedAssetShow" size="lg" :hide-footer="true" title="List of Fixed Asset" :centered="true">
            <lku-fixedasset @click="onSelectLkuFixedAsset" :catgid="model.assetCatgId" :catgname="model.assetCatgName" :formdata="lkuFixedAssetData"></lku-fixedasset>
        </b-modal>        
        <b-modal v-model="lkuRequestShow" size="lg" :hide-footer="true" title="List of Maintenance Request" :centered="true">
            <lku-requisition @click="onSelectLkuRequest"></lku-requisition>
        </b-modal>        
        <b-modal v-model="lkuMaintenguideShow" size="lg" :hide-footer="true" title="List of Maintenance Manual" :centered="true">
            <lku-maintenguide @click="onSelectLkuMaintenguide" :assetCatgId="model.catgid" :assetCatgName="model.catgname" :key="model.catgid"></lku-maintenguide>
        </b-modal>        
    </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 80px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuVendor from "../lookup/lkuVendor";
import lkuFixedasset from "../lookup/lkuFassetLazzy";
import lkuRequisition from "../lookup/lkuMaintenreq";
import lkuMaintenguide from "../lookup/lkuMaintenguide";
import workorder from "../../apis/maintenworko";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric, decimal } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber, vDim, lkuVendor, lkuFixedasset,lkuRequisition, lkuMaintenguide},
  mixins: [validationMixin],
  validations: {
        model: {
            asetkey: { required },
            orderdate: { required },
            vendor_id: {required : (function() {
                if ((this.model.internal || 0) == 0) {
                    return true;
                } else if (!(this.model.vendor_id)){
                    return false;
                } else return true;
            })},
            inspectName: { required },
            inspectDetail: { required },
        },
  }, 
  data() {
    return {
        saveEnabled:true,
        lkuRequestShow:false,
        lkuVendorShow: false,
        lkuFixedAssetData: {},
        lkuFixedAssetShow: false,
        lkuMaintenguideShow: false,
        updateDimHdr:false,
        updateDimDtl:true,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        uanguser: this.$store.state.user.matauang,
        currency:[{value:'IDR',text:'IDR'}],
        InterExtern : [{ value: 0, text: 'Vendor' }, { value: 1, text: 'Internal' }],
        model: {
            asetKey: 0,
            orderdate: moment().format('YYYY-MM-DD'),
            vendor_id: '',
            internal:0,
            requestno: '',
            inspectName: '',
            inspectDetail: '',
            matauang:this.$store.state.user.matauang, 
            costEstimate: 0
        },
        dimension:this.$store.state.dimension
    };
},
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  watch:{
    "model.internal": function(newval){
        if (newval === 1) {
            this.model.vendorinfo=this.model.departname;
        } else {
            this.model.vendorinfo=this.model.vendor;
        }
    },
  },
  created: async function(){
        if (this.$route.params.maintSpkKey)  {
          toastr.info('Loading WorkOrder Detail, please wait')
          try {
            const data = await workorder.detail(this.$route.params) ;
            // const data = await workorder.detail(this.$route.params);  
            const row = data[0][0];
            this.saveEnabled=((row.status || 0) === 0);
            row.orderdate = row.orderdate ? moment(row.orderdate).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.tanggalBerubah();
            this.updateDimHdr = !this.updateDimHdr;
                // this.$forceUpdate();                
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
        } else {
            this.model.orderdate  = moment().format('YYYY-MM-DD');
        }
  },
  methods: {
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;            
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else {
            try {
                this.model.TableName = 'maintenance_spk';
                const dimValResult = await dimension.validate(this.model);
                if (dimValResult.success) {
                    // this.model.DimTableKey = diisi dari PR/SR;
                    this.model.maintSpkKey = this.model.maintSpkKey || '';
                    this.model.maintSpkNo = this.model.maintSpkNo || '';
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.inspMstrKey = this.model.manualKey;
                    row.orderdate = moment(row.orderdate).format('YYYY-MM-DD');
                    row.vendor_id = (row.internal===1) ? '': row.vendor_id;
                    await workorder.save(row);
                    toastr.success("Complete successfully", "Save Order");
                    this.close();
                } else {
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message || 'Dimension validation error';
                    toastr.error(msg, "ERROR MESSAGE");
                    this.saveEnabled=true;            
                }

            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
                this.saveEnabled=true;            
            }

        }
    },
    onSelectLkuRequest: async function (_selected) {
        // this.model.requestkey = _selected.requestkey;
        // this.model.requestno = _selected.requestno;
        for (var key in _selected) {
            this.model[key] = _selected[key];
        }
        this.model.inspectDetail = _selected.inspectName;

        this.lkuRequestShow=false;
        this.updateDimHdr = !this.updateDimHdr;            
    },
    onSelectLkuVendor: async function (_selected) {
        this.model.vendorinfo = _selected.vendor_name.trim() + ' | ' + _selected.vendor_code.trim();
        this.model.vendor = _selected.vendor_name.trim() + ' | ' + _selected.vendor_code.trim();
        // this.model.vendor = _selected.vendor_code;
        this.model.vendor_id = _selected.vendor_id;
        this.lkuVendorShow=false;
    },
    onSelectLkuFixedAsset(lkuData) {
        this.lkuFixedAssetData=lkuData;
        this.lkuFixedAssetShow=false;

        this.model.asetkey = lkuData.selected.asetkey;
        this.model.asetid = lkuData.selected.asetid;
        this.model.asdesc = lkuData.selected.asdesc;
        // this.model.lamathn = lkuData.selected.lamathn;
        // this.model.lamabln = lkuData.selected.lamabln;
        this.model.catgname = lkuData.selected.catgname;
        this.model.matauang = lkuData.selected.matauang;
        this.model.asmodel = lkuData.selected.asmodel;
        this.model.asserial = lkuData.selected.asserial;
        this.model.asyermad = lkuData.selected.asyermad;
        this.model.supplierinfo = lkuData.selected.supplierinfo;
        this.model.departname = lkuData.selected.departname;
        // console.log('lkuData.selected.departname :',lkuData.selected.departname);
        // this.model.aspurcpri = lkuData.selected.aspurcpri;
        this.model.asdatacq = moment(lkuData.selected.asdatacq).format('YYYY-MM-DD');
    },
    onSelectLkuMaintenguide(_selected) {
        this.model.manualKey = _selected.inspMstrKey;
        this.model.referDoc = _selected.referDoc;
        this.model.manualName = _selected.inspectName;
        // this.model.catgid = _selected.assetCatgId;
        // this.model.catgname = _selected.assetCatgName;
        this.model.asmodel = _selected.assetModel;
        this.model.assetCatgId = _selected.assetCatgId;
        this.model.assetCatgName = _selected.assetCatgName;
        // this.$forceUpdate();
        this.lkuMaintenguideShow=false;
    },    

    // updateDimDtl2Hdr: function (dimDtl) {
    //     var dimHdr = this.model;
    //     this.dimension.forEach((dim) => {
    //         if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
    //             dimHdr[dim.value] = dimDtl[dim.value];
    //             dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
    //             dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
    //         }
    //     });
    //     this.updateDimHdr = !this.updateDimHdr;
    // },
    // updateDimHdr2Dtl: function (dimDtl) {
    //     var dimHdr = this.model;
    //     dimDtl = dimDtl || this.ordLinesObj;
    //     this.dimension.forEach((dim) => {
    //         if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
    //             dimDtl[dim.value] = dimHdr[dim.value];
    //             dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
    //             dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
    //         }
    //     });
    //     this.updateDimDtl = !this.updateDimDtl;
    // },
    tanggalBerubah: function(){
        this.tahun=moment(this.model.tanggal).format('YYYY');
    },
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'maintworkorderfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
          router.push("home");
      }
    }
  }
};
</script>
